module.exports = __webpack_public_path__ + "assets/img/play.10138cb6.png";